import { RulesPageAccessed } from "./RulesPageAccessed";

export const RulesPage = () => <RulesPageAccessed />;
